// extracted by mini-css-extract-plugin
export default {"label":"Calculator_label__p+AAN"};